module.exports = __webpack_public_path__ + "static/media/ig.ee008c9c.png";